import * as React from 'react';

import _t from 'i18n!nls/xdp';

const ToggleButtonForStreamlinedMWebSyllabusDescription = ({ collapsed }: { collapsed: boolean }) => (
  <span
    aria-label={_t('Read #{lessOrMore} about course material', { lessOrMore: collapsed ? _t('more') : _t('less') })}
  >
    {collapsed ? _t('Show description') : _t('Hide description')}
  </span>
);

export default ToggleButtonForStreamlinedMWebSyllabusDescription;
